<template>
  <div class="shipment_date">
    <h3 class="text-center __titleGlobal">Choose Your Shipment Date</h3>
    <div class="row __centerblock">
      <div class="col text-center">
        <div class="__myDatepick">
          <date-pick
              v-model="form.datePickup"
              :hasInputElement="false"
              :format="format"
              :parseDate="parseDate"
              :formatDate="formatDate"
              :displayFormat="'DD.MM.YYYY'"
              :isDateDisabled="isPastDate"
              >
          </date-pick>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import fecha from 'fecha'
import 'vue-date-pick/dist/vueDatePick.css'
import * as moment from 'moment'

export default {
  name: 'shipment_date',
  components: {
    DatePick
  },
  props: {
    showError: Boolean
  },
  data () {
    return {
      format: 'DD/MM/YY',
      form: {
        typeObj: 'sub',
        datePickup: moment().format('DD/MM/YY')
      },
      error: {}
    }
  },
  computed: {
    datePickup () {
      return this.form.datePickup
    }
  },
  watch: {
    datePickup (date) {
      this.$emit('IntantPriceShipmentDate', date)
      this.$emit('IntantPriceData', this.form)
    }
  },
  methods: {
    isPastDate (date) {
      var yesterday = new Date(Date.now() - 864e5)
      return date < yesterday
    },
    parseDate (dateString, format) {
      return fecha.parse(dateString, format)
    },
    formatDate (dateObj, format) {
      return fecha.format(dateObj, format)
    },
    init () {
      /* eslint-disable */
      this.error = (this.form.datePickup === '') ? true : false
      this.$emit('IntantPriceShipmentDate', this.form.datePickup)
      this.$emit('IntantPriceData', this.form)
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/ShipmentDate.vue